export const version = '1.1.0'
export const versionCode = 2 //increment + 1